import styled from "styled-components";

import backgroundImageSmall from "assets/images/svg/dots_background_small.svg";
import backgroundImage from "assets/images/svg/dots_background.svg";

import Button from "components/Button";

import styleConst from "constants/style";
import { MEDIA_QUERIES } from "constants/layout";
import { IconRight } from "components/Button/styles";

export const Background = styled.div`
  position: absolute;
  top: -100px;
  z-index: -1;

  height: 388px;
  width: 100%;

  overflow: hidden;
  background-repeat: no-repeat;
  background-position: 50% 50%;

  background-image: url(${backgroundImageSmall});

  ${MEDIA_QUERIES.DESKTOP} {
    background-image: url(${backgroundImage});
  }
`;

export const FavoriteButton = styled(Button)`
  width: 240px;

  padding: 1px 42px 1px 30px;
  margin-bottom: 25px;

  background: radial-gradient(
      83.3% 179.17% at 56.29% -31.25%,
      ${styleConst.colors.primaryMedium} 0%,
      ${styleConst.colors.primary} 100%
    ),
    ${styleConst.colors.primary};
  box-shadow: 0px 20px 40px -10px ${styleConst.colors.shadow};
  border-radius: 10px;
  border: none;
`;

export const Wrapper = styled.div`
  margin-bottom: 84px;
`;

export const CollectionWrapper = styled.div`
  margin-bottom: 8px;
`;

export const SectionTitle = styled.p`
  font-family: ${styleConst.fonts.montserrat};
  font-size: 26px;
  font-weight: 600;
  color: ${styleConst.colors.text};
  line-height: 48px;
`;

export const Title = styled.p`
  font-family: Montserrat;
  font-size: 44px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: 0px;
  text-align: left;
  padding: 0px 0px 25px 10px;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 10px 0 -50px;
`;

export const Card = styled.div`
  position: relative;

  justify-content: flex-end;

  height: 160px;

  border-radius: 10px;

  overflow: hidden;

  cursor: pointer;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 0 8px;
`;

export const ViewAllButton = styled(Button)`
  margin-top: 2px;
  padding-right: 0px;

  ${IconRight} {
    margin-left: 3px;
    margin-bottom: 2px;
  }
`;